<template>
  <div class="conversation-item-revoke">
    <p>{{tip(item)}}</p>
  </div>
</template>
<script>
  import {
    reactive,
    onMounted,
  } from 'vue'
  import {
    useRouter
  } from 'vue-router'
  // import {
  //   Toast
  // } from 'vant'
  import {
    useStore
  } from "vuex"
  import {
    Channel,
    ChannelTypePerson,
    WKSDK,
  } from "wukongimjssdk";


  export default {
    name: 'conversationitemrevoke',
    props: ['item'],
    setup() {
      const store = useStore()

      const router = useRouter()
      const state = reactive({
        uid: store.state.imuid,
      })

      const tip = (message) => {
        let name = "你"
        let revoker = message.remoteExtra.revoker
        if (revoker == store.state.imuid) {
          if (revoker != message.fromUID) {
            // let memberFromName = "--"
            // if (message.from) {
            //   memberFromName = message.from.title;
            // } else {
            //   WKSDK.shared().channelManager.fetchChannelInfo(new Channel(message.fromUID, ChannelTypePerson))
            // }
            // return `${name}撤回了成员“${memberFromName}”的一条消息`
            return `${name}撤回了成员的一条消息`
          }
          return `${name}撤回了一条消息`

        } else {
          const channel = new Channel(revoker ?? "", ChannelTypePerson)
          let channelInfo = WKSDK.shared().channelManager.getChannelInfo(new Channel(revoker ?? "",
            ChannelTypePerson))
          if (channelInfo) {
            name = channelInfo.title
          } else {
            WKSDK.shared().channelManager.fetchChannelInfo(channel)
            name = "--"
          }
          if (revoker != message.fromUID) {
            return `${name}撤回了一条成员消息`
          }
          return `${name}撤回了一条消息`
        }
      }

      onMounted(() => {

      })

      // 返回
      const onClickLeft = () => {
        router.back()
      }



      return {
        state,
        onClickLeft,
        tip,
      }
    }
  }
</script>
<style scoped="scoped">
  .conversation-item-revoke {
    padding: 20px 0;
    margin-bottom: 30px;
  }

  .conversation-item-revoke p {
    font-size: 24px;
    text-align: center;
    color: #999;
  }
</style>